module.exports = __webpack_public_path__ + "assets/cortex-db8dbf3dd8fd6c83d4d031298ce20345.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/cortex.jpg
// module id = 510
// module chunks = 1